import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
function CrmTicketLink({
  objectId,
  onClick,
  portalId,
  objectName
}) {
  const ticketHref = `/contacts/${portalId}/ticket/${objectId}`;
  const ticketName = objectName || `#${objectId}`;
  return /*#__PURE__*/_jsx(UILink, {
    className: "is--text--demibold m-left-1",
    href: ticketHref,
    onClick: onClick,
    external: true,
    children: ticketName
  });
}
CrmTicketLink.displayName = 'CrmTicketLink';
CrmTicketLink.propTypes = {
  objectId: PropTypes.number.isRequired,
  objectName: PropTypes.node,
  onClick: PropTypes.func,
  portalId: PropTypes.number.isRequired
};
export default CrmTicketLink;